export const IndexedDbConstants = {
  VERSION: 3,
  DB_NAME: "mut-indexed-db",
  FILES_OBJECT_STORE: "mut-files",
};

export const IndexDbStores: string[] = [IndexedDbConstants.FILES_OBJECT_STORE];
